/*!
 * Copyright (c) 2023 Digital Bazaar, Inc. All rights reserved.
 */
export const requiredAlgorithm = 'Ed25519';
